import {getTargetContainers, getTargetContainerSyncHandler} from '../utility/target-sync';

const COMPONENT_NAME = "tab-container";
const CLASS_SELECTOR = ".TabContainer";
const TAB_SELECTOR = ".Tab";
const DROPDOWN_SELECTOR = ".TabContainer-dropdown";
const TAB_CONTENT_SELECTOR = ".TabContent,[data-tab-content]";

const ACTIVE_CLASS = "is-active";

const instances = [];

function initialize(element, PageComponents) {
    if (element.classList.contains('is-standalone')) return;

    const targetSelector = element.getAttribute("data-target");
    const tabElements = element.querySelectorAll(TAB_SELECTOR);
    const contentElementList = getTargetContainers(targetSelector, TAB_CONTENT_SELECTOR, tabElements);
    if (contentElementList.length < 1) {
        console.error(`Error: could not find content target "${targetSelector}" for tab container`, element);
        return;
    }

    const dropdownElement = element.querySelector(DROPDOWN_SELECTOR);

    const tabs = [];
    //const options = [];
    let activeTabIndex = -1;

    function syncTabs(index) {
        tabElements.forEach((tab, i) => {
            tab.classList.toggle(ACTIVE_CLASS, i === index);
        });
    }
    function syncDropdown(index) {
        dropdownElement.selectedIndex = index;
    }
    const syncContent = getTargetContainerSyncHandler(contentElementList, ACTIVE_CLASS);

    function sync(index) {
        syncTabs(index);
        syncContent(index);
        activeTabIndex = index;
    }

    tabElements.forEach((tab, index) => {
        if (tab.classList.contains(ACTIVE_CLASS)) {
            activeTabIndex = index;
        }

        // Create dropdown option
        const option = document.createElement("option");
        option.value = index;
        option.text = tab.innerText;
        dropdownElement.appendChild(option);
        //options.push(option);

        // Add desktop tab click handler
        tab.addEventListener('click', (e) => {
            e.stopPropagation();
            sync(index);
            syncDropdown(index);
        });
    });
    if (activeTabIndex > -1) sync(activeTabIndex);

    // Dropdown change handler
    dropdownElement.addEventListener('change', (e) => {
        e.stopPropagation();
        sync(dropdownElement.selectedIndex);
    });

    instances.push({
        tabs,
        sync
    });
}

export default {
    name: COMPONENT_NAME,
    instances,
    initialize
};
